module.exports = __webpack_public_path__ + "bc4f1c46a9287cd830fd7e8609315c75.png";